import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { Theme, getBodyStyle, getColor } from 'styles/theme';

export const Description = styled.p<{ theme: Theme }>`
  padding: 8px 0;
  text-align: center;
  border-top: 1px solid ${getColor('borderSecondary')};
  ${getBodyStyle('graphikCond', { default: 'small' }, 'semiBold')};
  
  @media (${breakpoint.lgMin}) {
    width: 80%;
    margin: 0 auto;
  }

`;

export const Columns = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;

  @media (${breakpoint.mdMin}) {
    flex-direction: row;
    justify-content: center;

    ul, ul ~ ul {
      max-width: 450px;
    }

    ul:only-child {
      max-width: 600px;
    }
  }
`;

export const Column = styled.ul`
  flex: 1 1 0;
`;

export const Item = styled.li<{ theme: Theme }>`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  ${getBodyStyle('graphikCond', { default: 'default' })};


  & > * {
    flex: 1;
  }

  span {
    display: inline-block;
  }

  span:first-of-type {
    font-weight: 500;
    flex: 1;
  }

  .link {
    padding: 0;
    line-height: unset;
    letter-spacing: 0.5px;
    text-align: left;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (${breakpoint.mdMin}) {
    gap: 24px;
  }
`;
